import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Download, Printer } from "lucide-react";
import { InvoicePaper, printPdfBlob } from "@/components/InvoicePaper";

const toPaper = (inv) => ({
  type: inv.invoice_type || "tax", serial: inv.serial, invoiceDate: inv.invoice_date, billTo: inv.bill_to || {},
  preparedBy: inv.prepared_by || inv.created_by || "", items: inv.line_items || [],
  gstEnabled: inv.gst_enabled !== false, gstMode: inv.gst_mode, gstPercent: inv.gst_percent ?? 0,
});

export default function PublicInvoice() {
  const { token, invoiceId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const pdfUrl = `${API}/track/${token}/invoice-pdf?invoice_id=${invoiceId}`;

  useEffect(() => {
    axios.get(`${API}/track/${token}/invoice/${invoiceId}`).then((r) => setData(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Invoice not found"));
  }, [token, invoiceId]);

  const print = async () => {
    try { const r = await axios.get(pdfUrl, { responseType: "blob" }); printPdfBlob(r.data); } catch { toast.error("Could not load the invoice PDF"); }
  };

  return (
    <div className="min-h-screen bg-neutral-100 dark:bg-neutral-900 p-3 sm:p-6 space-y-4" data-testid="public-invoice-page">
      <div className="max-w-[920px] mx-auto flex flex-wrap gap-2 items-center">
        <Button variant="ghost" className="rounded-none gap-1.5 mr-auto" onClick={() => navigate(`/track/${token}`)} data-testid="pub-inv-back"><ArrowLeft className="h-4 w-4" /> Back to Order</Button>
        <Button variant="outline" className="rounded-none gap-1.5" onClick={() => window.open(pdfUrl, "_blank")} disabled={!data} data-testid="pub-inv-download"><Download className="h-4 w-4" /> Download PDF</Button>
        <Button className="rounded-none gap-1.5" onClick={print} disabled={!data} data-testid="pub-inv-print"><Printer className="h-4 w-4" /> Print</Button>
      </div>
      {err && <div className="max-w-[920px] mx-auto p-6 text-center text-muted-foreground border border-border bg-card">{err}</div>}
      {!data && !err && <div className="p-10 text-center text-muted-foreground">Loading invoice…</div>}
      {data && <div className="overflow-x-auto"><InvoicePaper d={toPaper(data.invoice)} cs={data.company} /></div>}
    </div>
  );
}
